import ForgetPassword from './ForgetPassword';

export default {
  name: 'ForgetPassword',
  location: '/forget-password',
  component: ForgetPassword,
};
